import * as React from 'react';

import { IBaseQuestionProps } from '../FormContainer/types/internal';
import { useBooleanState } from '@cian/valuation-utils-component';
import { ModalLoader } from '../../components/ModalLoader';
import { ErrorBlock } from '../../components/ErrorBlock';
import { SpecificWrapper } from '../../components/SpecificWrapper/SpecificWrapper';

export const HiddenSubmitterQuestion: React.FC<React.PropsWithChildren<IBaseQuestionProps>> = props => {
  const { answersState, setNextStep, error, submitButtonText } = props;
  const [isSent, setIsSent] = useBooleanState();

  const handleSubmitForm = React.useCallback(() => {
    setNextStep(answersState);
    setIsSent();
  }, [answersState, setNextStep, setIsSent]);

  React.useEffect(() => {
    if (!isSent) {
      setNextStep(answersState);
      setIsSent();
    }
  }, [answersState, isSent, setNextStep, setIsSent]);

  if (error) {
    return (
      <SpecificWrapper>
        <ErrorBlock
          title="Ошибка"
          text={error}
          buttonText={submitButtonText || 'Повторить отправку'}
          onClick={handleSubmitForm}
        />
      </SpecificWrapper>
    );
  }

  return (
    <SpecificWrapper>
      <ModalLoader />
    </SpecificWrapper>
  );
};
